import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import ImmutablePropTypes from 'react-immutable-proptypes'
import classNames from 'classnames'
import { Link } from 'react-router'
import Star from './icons/star'
import Home from './icons/home'

const WeatherFavoriteLocations = ({
  currentLocationId,
  currentLocationName,
  isCurrentFavorite,
  isCurrentDefault,
  userLocations,
  userDefaultLocationId,
  onSetDefault,
  onFavoriteClick,
}) => (
  <div className='weather-favorite-locations'>
    <div className='weather-favorite-locations__current-location'>
      <span className='weather-favorite-locations__current-location-title'>Nykyinen sijainti</span>
      { !!currentLocationId &&
        <span className='weather-favorite-locations__current-location-name-container'>
          <span className='weather-favorite-locations__current-location-name'>{ currentLocationName }</span>

          <button
            type='button'
            className='weather-favorite-locations__current-location__button'
            onClick={ onSetDefault } data-location-id={ currentLocationId }
            aria-label={ isCurrentDefault ? 'Oletussijainti' : 'Aseta oletussijainniksi' }
            title={ isCurrentDefault ? 'Tämä on sääsivun oletussijainti' : 'Aseta oletussijainniksi' }
          >
            <Home className={ classNames('weather-favorite-locations__current-location__button-home', {'default-current-location': isCurrentDefault} ) } />
          </button>

          <button
            type='button'
            className='weather-favorite-locations__current-location-button'
            onClick={ onFavoriteClick }
            data-location-id={ currentLocationId }
            aria-label={ isCurrentFavorite ? 'Poista suosikeista' : 'Lisää suosikkeihin' }
            title={ isCurrentFavorite ? 'Poista suosikeista' : 'Lisää suosikkeihin' }
          >
            <Star
              className={ classNames('weather-favorite-locations__current-location__button-star', {'current-favorited-location': isCurrentFavorite} ) }
            />
          </button>
        </span>
      }
    </div>

    <div className='weather-favorite-locations__list-container'>
      <span className='weather-favorite-locations__list-title'>Suosikit</span>
      <ul className='weather-favorite-locations__list'>
        { userLocations.map(loc => {
          const isLocDefault = loc.get('id') === userDefaultLocationId
          return (
            <li
              key={ loc.get('slug') }
              className='weather-favorite-locations__list-item'
              data-location={ loc.get('id') }
            >
              <Link to={ '/saa/' + loc.get('slug') } className='weather-favorite-locations__list-item-link'>
                { loc.get('name') }
              </Link>
              <button
                onClick={ onSetDefault }
                data-location-id={ loc.get('id') }
                className='weather-favorite-locations__list-item__button'
                aria-label={ isLocDefault ? 'Oletussijainti' : 'Aseta oletussijainniksi' }
                title={ isLocDefault ? 'Tämä on sääsivun oletussijainti' : 'Aseta oletussijainniksi' }
              >
                <Home className={ classNames('weather-favorite-locations__list-item__button-home', {'default-favorited-location': isLocDefault}) } />
              </button>
              <button
                onClick={ onFavoriteClick }
                data-location-id={ loc.get('id') }
                className='weather-favorite-locations__list-item__button'
                aria-label={ isLocDefault ? 'Oletussijaintia ei voi poistaa suosikeista' : 'Poista suosikeista' }
                title={ isLocDefault ? 'Oletussijaintia ei voi poistaa suosikeista' : 'Poista suosikeista' }
              >
                <Star className={ classNames('weather-favorite-locations__list-item__button-star', {'default-favorited-location': isLocDefault}) } />
              </button>
            </li>
          )
        }) }
      </ul>
    </div>
  </div>
)

WeatherFavoriteLocations.propTypes = exact({
  currentLocationId: PropTypes.number,
  currentLocationName: PropTypes.string.isRequired,
  isCurrentFavorite: PropTypes.bool.isRequired,
  isCurrentDefault: PropTypes.bool.isRequired,
  userLocations: ImmutablePropTypes.orderedSet.isRequired,
  userDefaultLocationId: PropTypes.number,
  onSetDefault: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
})

export default WeatherFavoriteLocations
